













































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Ajax from "@/lib/ajax";
import ajax from "@/lib/ajax";
class NotificeModel {
  message: string = "";
  noticeType: number = 0;
  activityType: number | null = 0;
  paramsId: number | null = null;
}
@Component({
  components: {},
})
export default class Notifice extends AbpBase {
  notificeModel: NotificeModel = new NotificeModel();
  radioUser: string = "all";
  list: any = [];
  courts: any = [];
  constitutes: any = [];
  tickets: any = [];
  secondHands: any = [];
  memberShips: any = [];
  async save() {
    if (this.notificeModel.noticeType == 0) {
      this.notificeModel.activityType = null;
      this.notificeModel.paramsId = null;
    }
    (this.$refs.notificeForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.$Modal.info({
          title: "提示信息",
          content: "确定要全员推送该消息吗？",
          onOk: () => {
            this.confirmSave();
          },
        });
      } else {
        this.$Message.error({
          content: "表单校验不通过,请检查",
        });
      }
    });
  }
  changeNoticeType(e) {
    switch (e) {
      case 0:
        this.list = this.courts;
        break;
      case 1:
        this.list = this.constitutes;
        break;
      case 2:
        this.list = this.tickets;
        break;
      case 3:
        this.list = this.memberShips;
        break;
        case 4:
        this.list = this.secondHands;
        break;
      default:
        break;
    }
  }
  async confirmSave() {
    await Ajax.post(
      "/api/services/app/Notification/SendNotificationsToAllUser",
      this.notificeModel
    );
    this.notificeModel.message = "";
    this.notificeModel.activityType = null;
    this.notificeModel.noticeType = 0;
    this.notificeModel.paramsId = null;
    this.$Message.success({
      content: "推送消息任务后台执行中,请关掉窗口后耐心等待发送完成....",
    });
  }

  async getList() {
    let res = await ajax.get("/api/services/app/Court/GetLableAndValue");
    if (res && res.data && res.data.result) {
      this.courts = res.data.result.courts;
      this.constitutes = res.data.result.constitutes;
      this.tickets = res.data.result.tickets;
      this.memberShips = res.data.result.memberShips;
      this.secondHands = res.data.result.secondHands;
      this.list = this.courts;
    }
  }
  created() {
    this.getList();
  }
  notificeRule = {
    message: [
      {
        required: true,
        message: "请输入推送消息",
        trigger: "blur",
      },
    ],
  };
}
